import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  secondary: {
    fontStyle: 'italic',
    lineHeight: 1,
    fontSize: '0.8rem',
  },
  progress: {
    color: `${(theme as any).palette.success.main}`,
    cursor: 'pointer',
  },
  progressDelete: {
    color: `${(theme as any).palette.success.main}`,
    cursor: 'pointer',
  },
  submitted: {
    color: `${(theme as any).palette.text.primary}`,
  },
  lock: {
    marginBottom: 5,
  },
  dialog: {
    position: 'absolute',
    left: 10,
    top: 50,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px',
  },
  radioLabel: {
    fontSize: '1rem',
    marginBottom: '0px',
  },
  label: {
    fontSize: '1rem',
  },
  timePicker: {},
  episodePicker: {
    backgroundColor: `${(theme as any).palette.background.paper}`,
    maxHeight: '28px',
    borderRadius: '3px',
    paddingLeft: '5px',
  },
  inputBase: {
    color: `${(theme as any).palette.text.default}`,
    fontWeight: 500,
    backgroundColor: `${(theme as any).palette.background.paper}`,
    borderRadius: '3px',
    paddingLeft: '5px',
    '&&:disabled': {
      color: 'grey',
    },
    '&::before': {
      content: '',
      display: 'none',
      borderBottom: 0,
    },
  },
  button: {
    height: '35px',
    lineHeight: '1rem',
  },

  menuButton: {
    height: '35px',
    lineHeight: 1.25,
    textAlign: 'center',
    padding: '10px',
    whiteSpace: 'normal',
    '@media (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      minHeight: '36px',
      fontSize: '0.9rem',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 6,
      paddingRight: 6,
    },
  },

  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
  },
  startVisitContent: {
    paddingTop: theme.spacing(3),
  },
  warningStyle: {
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.error.main,
    fontSize: '1.2rem',
    '@media (max-width: 600px)': {
      fontSize: '0.875rem',
      marginBottom: theme.spacing(2),
    },
  },
  dialogMessage: {
    margin: 0,
    marginBottom: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      fontSize: '0.875rem',
    },
  },
  menuStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    gap: '16px',
    width: '100%',
    marginBottom: theme.spacing(2),
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
    },
  },
}));
